import React, { useState } from 'react';
import './css/app1.css';

import banner_logo1 from './logos/final/logo-01.png';
import banner_logo2 from './logos/final/logo-02.png';
import banner_logo3 from './logos/final/logo-03.png';
import img1 from './icons/seo.png';
import img2 from './icons/web-development.png';
import img3 from './icons/design-service.png';
import img4 from './icons/content.png';
import img5 from './icons/seo.png';

export default function Banner() {
  const [currentIndex, setCurrentIndex] = useState(0);

  const contents = [
    {
      title: 'Improve search rankings  ',
      subtitle: 'SEO Optimization',
      description: 'Drive organic traffic with targeted keywords',
      buttonText: 'VIEW CASE STUDY',
    },
    {
      title: 'Build responsive websites',
      subtitle: 'Web Development',
      description: 'Create user-friendly, high-performance web solutions',
      buttonText: 'VIEW CASE STUDY',
    },
    {
      title: 'Craft unique visuals',
      subtitle: 'Designer Services',
      description: 'Design impactful, aesthetically pleasing user interfaces',
      buttonText: 'VIEW CASE STUDY',
    },
    {
      title: 'Engage your audience',
      subtitle: 'Content Creation',
      description: 'Produce high-quality, relevant, and engaging content',
      buttonText: 'VIEW CASE STUDY',
    },
  ];

  const handlePrev = () => {
    const index = currentIndex === 0 ? contents.length - 1 : currentIndex - 1;
    setCurrentIndex(index);
  };

  const handleNext = () => {
    const index = currentIndex === contents.length - 1 ? 0 : currentIndex + 1;
    setCurrentIndex(index);
  };

  const handleClickImg = (index) => {
    setCurrentIndex(index);
  };

  return (
    <>
      <div className="row ab1">
        <div className="main1 col-md-6">
          <div className="header-section">
            <h1>
              <span>Our Expertise in </span>
              <br />
                Digital Marketing 
            </h1>
          </div>
          <div className="para">
            <p>We specialize in creating targeted campaigns that leverage the latest tools and technologies, ensuring that your brand reaches the right audience at the right time.</p>
          </div>
          <div className="btn btn1">
            <a href="/">WORK WITH US</a>
          </div>
          <div className="banner-logo">
            <img src={banner_logo1} alt="" srcSet="" />
            <img src={banner_logo2} alt="" srcSet="" />
            <img src={banner_logo3} alt="" srcSet="" />
          </div>
        </div>
        <div className="main2 col-md-6">
          <div className="carousel">
            <div className="carousel-content">
              <h6>{contents[currentIndex].title}</h6>
              <h1>{contents[currentIndex].subtitle}</h1>
              <p>{contents[currentIndex].description}</p>
              <a>{contents[currentIndex].buttonText}</a>
            </div>
            <button className="carousel-button prev" onClick={handlePrev}>
              &lt;
            </button>
            <button className="carousel-button next" onClick={handleNext}>
              &gt;
            </button>
          </div>

          <div className="tab_img">
            <div className="imgbtn">
              <button
                className={`tab-btn4 ${currentIndex === 0 ? 'active' : ''}`}
                onClick={() => handleClickImg(0)}
              >
                <div className="tab-img1">
                  <img src={img1} alt="" />
                </div>
              </button>
            </div>

            <div className="imgbtn">
              <button
                className={`tab-btn4 ${currentIndex === 1 ? 'active' : ''}`}
                onClick={() => handleClickImg(1)}
              >
                <div className="tab-img1">
                  <img src={img2} alt="" />
                </div>
              </button>
            </div>

            <div className="imgbtn">
              <button
                className={`tab-btn4 ${currentIndex === 2 ? 'active' : ''}`}
                onClick={() => handleClickImg(2)}
              >
                <div className="tab-img1">
                  <img src={img3} alt="" />
                </div>
              </button>
            </div>

            <div className="imgbtn">
              <button
                className={`tab-btn4 ${currentIndex === 3 ? 'active' : ''}`}
                onClick={() => handleClickImg(3)}
              >
                <div className="tab-img1">
                  <img src={img4} alt="" />
                </div>
              </button>
            </div>
          </div>
        </div>
      </div>
    </>
  );
}
